import React, { Component } from "react";
import 'static/css/popup.css';
import popupCross from 'static/image/popupCross.png'
import {closePopup} from "utils/CommonUtils";

class AlertMessagePopup extends Component {
    render() {
        return (
            <div className="MBack popup AlretMessagePopup hide" id={this.props.id}>
                <div className="MPopupBox popupContent">
                    <div className="MTitle">
                        <h2>{this.props.title}</h2>
                        <img src={ popupCross } alt="닫기" className="eventBtn closeBtn" onClick={() => closePopup(this.props.id)} />
                    </div>
                    <div className="MText">
                        {this.props.text}
                    </div>
                    <div className="MBtn">
                        <button className="eventBtn closeBtn" onClick={() => closePopup(this.props.id)}>닫기</button>
                    </div>
                </div>
            </div>
        )
    }
}

export { AlertMessagePopup };